'use strict';

// EXPORTS //

module.exports = Math.exp;
